<template>
  <div class="h2 p-4 d-flex align-items-center justify-content-center">
    <div
      v-if="currentStep >= 1"
      :class="{'primary-color': currentStep === 1, 'cursor-pointer': links[0] !== undefined}"
      @click="onClick(1)"
    >
      Votre profil <span v-if="currentStep > 1">></span>
    </div>
    <div
      v-if="currentStep >= 2"
      :class="{'primary-color': currentStep === 2, 'cursor-pointer': links[1] !== undefined}"
      @click="onClick(2)"
    >
      Tableau de garanties <span v-if="currentStep > 2">></span>
    </div>
    <div
      v-if="currentStep >= 3"
      :class="{'primary-color': currentStep === 3, 'cursor-pointer': links[2] !== undefined}"
      @click="onClick(3)"
    >
      Informations complémentaires <span v-if="currentStep > 3">></span>
    </div>
    <div
      v-if="currentStep >= 4"
      :class="{'primary-color': currentStep === 4}"
    >
      Récapitulatif <span v-if="currentStep > 4">></span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SlHeader',
  props: {
    currentStep : {
      type: Number,
      required: true
    },
    links: {
      type: Array,
      required: false,
      default: () => []
    }
  },
  setup(props) {
    const onClick = (step) => {
      if (props.links[step-1] !== undefined) {
        //console.debug('[SlHeader]', 'onClick', props.links[step-1])
        //console.error(window.parent)
        if (window.parent) {
          //window.parent.location = props.links[step-1]
          // Envoi d'un message vers la page parente
          window.parent.postMessage({
            action: 'navigate',
            url: props.links[step-1],
            height: document.getElementById("app").scrollHeight
          }, '*');
        } else {
          window.location = props.links[step-1]
        }
      }
    }

    return {
      onClick
    }
  }
}
</script>

<style lang="scss" scoped>
  .cursor-pointer {
    cursor: pointer
  }
</style>
